export default __webpack_public_path__ + "static/media/cp-logo.a56b4b75.png";